import React, { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { PaginationProps } from "../interFaces/interfaces";
import "../css/others/Table.css";
const Pagination: React.FC<PaginationProps> = ({ currentPage, totalPages, totalElements, itemsPerPage, onPageChange, onItemsPerPageChange }) => {
  const location = useLocation();
  const storageKey = `paginationPage_${location.pathname}`;
  const isInitialLoad = useRef(true);
  useEffect(() => {
    if (isInitialLoad.current) {
      const savedPage = sessionStorage.getItem(storageKey);
      if (savedPage) {
        const pageNum = Number(savedPage);
        if (pageNum > 0 && pageNum <= totalPages) {
          if (pageNum !== currentPage) {
            onPageChange(pageNum);
          }
        } else if (pageNum > totalPages && totalPages > 0) {
          onPageChange(totalPages);
        }
      }
      isInitialLoad.current = false;
    }
  }, [currentPage, onPageChange, storageKey, totalPages]);
  useEffect(() => {
    if (currentPage > 0 && currentPage <= totalPages) {
      sessionStorage.setItem(storageKey, String(currentPage));
    }
  }, [currentPage, storageKey, totalPages]);
  const handleFirstPage = () => onPageChange(1);
  const handlePreviousPage = () => onPageChange(Math.max(1, currentPage - 1));
  const handleNextPage = () => onPageChange(Math.min(totalPages, currentPage + 1));
  const handleLastPage = () => onPageChange(totalPages);
  const handleItemsPerPageChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const newItemsPerPage = Number(event.target.value);
    onItemsPerPageChange(newItemsPerPage);
    onPageChange(1);
    sessionStorage.removeItem(storageKey);
  };
  const startItem = totalElements === 0 ? 0 : (currentPage - 1) * itemsPerPage + 1;
  const endItem = Math.min(currentPage * itemsPerPage, totalElements);
  const getPageNumbers = () => {
    const pages = [];
    let start = Math.max(1, currentPage - 1);
    let end = Math.min(totalPages, start + 2);
    if (end - start < 2 && start > 1) {
      start = Math.max(1, end - 2);
    }
    for (let i = start; i <= end; i++) {
      pages.push(i);
    }
    return pages;
  };
  const pageNumbers = getPageNumbers();
  return (
    <div className="pagination">
      <button className="back-btn" onClick={() => window.history.back()}>Back</button>
      <button className="info"> Showing {startItem} to {endItem} of {totalElements} items</button>
      <div className="pagination-controls">
        <button onClick={handleFirstPage} className="pagination-btn" disabled={currentPage === 1}>
          <span className="small-pipe">|</span>&#8249;
        </button>
        <button onClick={handlePreviousPage} className="pagination-btn" disabled={currentPage === 1}> &#8249; </button>
        {pageNumbers.map((page) => (
          <button key={page} onClick={() => onPageChange(page)} className={`pagination-btn ${currentPage === page ? "active" : ""}`}> {page} </button>
        ))}
        <button onClick={handleNextPage} className="pagination-btn" disabled={currentPage === totalPages}> &#8250;</button>
        <button onClick={handleLastPage} className="pagination-btn" disabled={currentPage === totalPages}>  &#8250;<span className="small-pipe">|</span></button>
      </div>
      <div>
        <select id="itemsPerPageSelect" value={itemsPerPage} onChange={handleItemsPerPageChange} className="items-perpage-select">
          <option value={10}>10</option>
          <option value={25}>25</option>
          <option value={50}>50</option>
          <option value={100}>100</option>
        </select>
      </div>
    </div>
  );
};
export default Pagination;